import { EventEmitter, Injectable, Output} from "@angular/core";
import {MainPageDetailModel} from "../models/plans.model";
import {StateModel} from "../models/state.model";
import { environment } from "../../environments/environment";

@Injectable()
export class EventsManager {
  @Output() showHideSubheader: EventEmitter<boolean> = new EventEmitter();
  @Output() officeUpdate: EventEmitter<any> = new EventEmitter();
  @Output() planDetailUpdate: EventEmitter<any> = new EventEmitter();
  @Output() levelSelected: EventEmitter<any> = new EventEmitter();
  @Output() feeScheduleUpdate: EventEmitter<any> = new EventEmitter();
  @Output() showPaymentScreen: EventEmitter<any> = new EventEmitter();
  @Output() showSuccessScreen: EventEmitter<any> = new EventEmitter();
  @Output() togglePrimary: EventEmitter<any> = new EventEmitter();
  @Output() sendSuccessfulPayment: EventEmitter<any> = new EventEmitter();
  @Output() sendPaymentError: EventEmitter<any> = new EventEmitter();
  @Output() sendPaymentTimeout: EventEmitter<any> = new EventEmitter();
  @Output() acceptMemberAgreement: EventEmitter<any> = new EventEmitter();
  @Output() setPurchaseStep: EventEmitter<any> = new EventEmitter();
  @Output() loadingState: EventEmitter<any> = new EventEmitter();
  @Output() getwWhoIsPrimary: EventEmitter<any> = new EventEmitter();
  @Output() memberCountUpdate: EventEmitter<any> = new EventEmitter();
  @Output() updateForm: EventEmitter<any> = new EventEmitter();
  @Output() taxPercUpdated: EventEmitter<any> = new EventEmitter();
  @Output() statesLoaded: EventEmitter<any> = new EventEmitter();
  @Output() getPlanOptions: EventEmitter<any> = new EventEmitter();
  @Output() contactInfoUpdated: EventEmitter<any> = new EventEmitter();
  @Output() homePageDetailUpdated: EventEmitter<string> = new EventEmitter();
  @Output() isAdminByUpdated: EventEmitter<string> = new EventEmitter();
  @Output() planDataUpdated: EventEmitter<string> = new EventEmitter();
  @Output() hideHeader: EventEmitter<boolean> = new EventEmitter();

  docOrgId:string = '';
  orgId:string = '';
  officeInfo?: MainPageDetailModel = undefined;
  planDetailInfo: any = {};
  selectedLevel:any = {};
  feeScheduleInfo: any = {};
  showLoading:boolean = false;
  legalLanguage:any = {};
  isLocationConfirmPage:boolean = false;
  isLocationOff:boolean = false;
  states:StateModel[] = [];
  selectedState:StateModel = {name:'',value:'',abbr:''};
  planOptions:any = {};
  isAdminBy:string = 'wellfit';
  contactInfo:any ={};
  planId:string = '';
  homePageDetails:any = {};
  planEmail:string = environment.planEmail;
  planName:string = 'Smile Generation Dental Plan';
  planYear:string = '';
  allowedStates:any = {};
  supportStates:StateModel[] = [];
  hideTopHeader:boolean = false;
  purchaseIsADHA: boolean = false;
  adhaPractice: string = '1D550000-FFFF-000D-889B-08D43C1753AA'; // Hardcoded practice ID for ADHA

  constructor(){}

  subHeaderShowHide(evt: boolean){
    this.showHideSubheader.emit(evt);
  }

  getOfficeInfo(){
    let office:any = {};
    if(this.officeInfo?.name){
      office = this.officeInfo;
    } else if(sessionStorage['office']){
      office = JSON.parse(sessionStorage['office']);
      this.officeInfo = office;
    }

    return office;
  }

  getFeeScheduleInfo(){
    if(!this.feeScheduleInfo.pageName){
      this.setFeeScheduleInfo({});
    }

    return this.feeScheduleInfo;
  }

  getLegalLanguage(){
    return this.legalLanguage;
  }

  setOfficeInfo(office:MainPageDetailModel){
    sessionStorage['office'] = JSON.stringify(office);
    this.officeInfo = office;
    this.officeUpdate.emit(office);
  }

  setPlanDetails(details:any){
    sessionStorage['planDetails'] = JSON.stringify(details);
    this.planDetailInfo = details;
    this.planDetailUpdate.emit();
  }

  setLevelSelected(level:any){
    sessionStorage['level'] = JSON.stringify(level);
    this.selectedLevel = level;
    this.levelSelected.emit();
  }

  setFeeScheduleInfo(feeSchedule:any){
    if(this.feeScheduleInfo.practiceId){
      this.feeScheduleInfo = feeSchedule;
    } else if(sessionStorage['fees']){
      this.feeScheduleInfo = JSON.parse(sessionStorage['fees']);
    }
    //console.log('fees: ', JSON.parse(sessionStorage['fees']));
    this.feeScheduleUpdate.emit(this.feeScheduleInfo);
  }

  setLoadingState(state:boolean){
    this.showLoading = state;
    this.loadingState.emit(this.showLoading);
  }

  setLegalLanguage(data:any){
    this.legalLanguage = data;
  }

  setStates(states:StateModel[]) {
    this.states = states;
    this.statesLoaded.emit();
  }

  setIsAdminBy(isAdminBy:string){
    this.isAdminBy = isAdminBy;
    if(isAdminBy == null){
      this.isAdminBy = 'wellfit';
    }
    this.isAdminByUpdated.emit(this.isAdminBy);
  }

  setHideHeader(hide:boolean){
    this.hideTopHeader = hide;
    this.hideHeader.emit(this.hideTopHeader);
  }
  
  lookUpState(name:string){
    let found: StateModel = {name:'',value:'',abbr:''};
    for(let i:number = 0;i<this.states.length;i++){
      if(this.states[i].abbr === name){
        found = this.states[i];
        break;
      }
    }
    return found;
  }

  isStateAllowed(state:string):boolean {
    let found: boolean = false;
    for(let s:number = 0;s<this.allowedStates.length;s++){
      if(this.allowedStates[s].abbr === state){
        found = true;
        break;
      }
    }
    return found;
  }
}
